import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { useForm } from "react-hook-form";
import Modal from "components/Modals/index";
import { removeSeat, updateRemoveSeatsModal } from "reducers/company";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import {
  Button,
  Stack,
  Box,
  List,
  ListItem,
  ListItemText
} from "@mui/material";
import { moneyFieldConverter } from "utils";

const RemoveSeatsConfirmModal = ({ isOpen, handleClose }) => {
  const dispatch = useDispatch();

  const { removeSeats, removeSeatsQuantity } = useSelector(
    state => state.company
  );

  const { handleSubmit } = useForm();

  const onSubmit = () => {
    let removeSeatsDetail = {
      removeSeats: removeSeatsQuantity
    };
    dispatch(removeSeat(removeSeatsDetail));
    handleClose();
  };

  const handleBackBtn = () => {
    dispatch(updateRemoveSeatsModal(true));
    handleClose();
  };

  return (
    <Modal isOpen={isOpen} handleClose={handleClose} title="Remove Seats">
      <Button
        variant="text"
        sx={{ marginBottom: "16px" }}
        startIcon={<ArrowBackIcon />}
        onClick={handleBackBtn}
      >
        Change
      </Button>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Stack
          direction="row"
          sx={theme => ({
            [theme.breakpoints.down("sm")]: {
              flexWrap: "wrap"
            }
          })}
        >
          <Box
            sx={theme => ({
              background: theme.palette.text.dark.primary,
              padding: "14px",
              width: "100%",
              height: "100%",
              borderRadius: "8px",
              marginRight: "24px",
              [theme.breakpoints.down("sm")]: {
                background: theme.palette.background.default,
                marginRight: 0,
                marginBottom: "16px"
              }
            })}
          >
            <List
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: 0
              }}
            >
              <ListItem disablePadding sx={{ width: "unset" }}>
                <ListItemText
                  primary="Remove Seats"
                  sx={{ color: "text.primary" }}
                />
              </ListItem>
              <ListItem disablePadding sx={{ width: "unset" }}>
                <ListItemText
                  primary={removeSeats?.removeSeats}
                  sx={{ color: "text.primary" }}
                />
              </ListItem>
            </List>
            <List
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: 0
              }}
            >
              <ListItem disablePadding sx={{ width: "unset" }}>
                <ListItemText
                  primary="Per Seat"
                  sx={{ color: "text.primary" }}
                />
              </ListItem>
              <ListItem disablePadding sx={{ width: "unset" }}>
                <ListItemText
                  primary={moneyFieldConverter(removeSeats?.perSeatAmount)}
                  sx={{ color: "text.primary" }}
                />
              </ListItem>
            </List>
            <List
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: 0
              }}
            >
              <ListItem disablePadding sx={{ width: "unset" }}>
                <ListItemText
                  primary="Payable Today"
                  sx={{ color: "text.primary" }}
                />
              </ListItem>
              <ListItem disablePadding sx={{ width: "unset" }}>
                <ListItemText
                  primary={moneyFieldConverter(removeSeats?.payableToday)}
                  sx={{ color: "text.primary" }}
                />
              </ListItem>
            </List>
          </Box>
          <Box
            sx={theme => ({
              background: theme.palette.text.dark.primary,
              padding: "14px",
              width: "100%",
              height: "100%",
              borderRadius: "8px",
              [theme.breakpoints.down("sm")]: {
                background: theme.palette.background.default
              }
            })}
          >
            <List
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: 0
              }}
            >
              <ListItem disablePadding sx={{ width: "unset" }}>
                <ListItemText
                  primary="Total Seats"
                  sx={{ color: "text.primary" }}
                />
              </ListItem>
              <ListItem disablePadding sx={{ width: "unset" }}>
                <ListItemText
                  primary={removeSeats?.totalSeats}
                  sx={{ color: "text.primary" }}
                />
              </ListItem>
            </List>
            <List
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: 0
              }}
            >
              <ListItem disablePadding sx={{ width: "unset" }}>
                <ListItemText
                  primary="Per Seat"
                  sx={{ color: "text.primary" }}
                />
              </ListItem>
              <ListItem disablePadding sx={{ width: "unset" }}>
                <ListItemText
                  primary={moneyFieldConverter(removeSeats?.perSeatAmount)}
                  sx={{ color: "text.primary" }}
                />
              </ListItem>
            </List>
            <List
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: 0
              }}
            >
              <ListItem disablePadding sx={{ width: "unset" }}>
                <ListItemText
                  primary="Next Invoice"
                  sx={{ color: "text.primary" }}
                />
              </ListItem>
              <ListItem disablePadding sx={{ width: "unset" }}>
                <ListItemText
                  primary={moneyFieldConverter(removeSeats?.nextPayable)}
                  sx={{ color: "text.primary" }}
                />
              </ListItem>
            </List>
          </Box>
        </Stack>
        <Button
          sx={theme => ({
            marginTop: 3,
            width: "100%"
          })}
          type="submit"
          variant="contained"
        >
          Confirm
        </Button>
      </form>
    </Modal>
  );
};

export default RemoveSeatsConfirmModal;
